import { useContext } from "react";
import { useSelector } from "react-redux";
import { Identifiable, Milestone } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  removeMilestone(milestone: Boundaries["removeMilestone"]["request"]): void;
}

function useRemoveMilestone(milestone: Identifiable<Milestone>): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRemoveMilestoneRequestPending(milestone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRemoveMilestoneRequestSuccess(milestone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRemoveMilestoneRequestFailure(milestone),
    ),
    removeMilestone: core.removeMilestone,
  };
}

export { useRemoveMilestone };
